import { ComponentProps } from 'react';

import { BulkActionsBarButton } from '~components/BulkActionsBar/BulkActionsBar';
import { SmallLoadingButton } from '~components/Order/ordersDispatchStyledComponents';

interface DispatchTriggerButtonProps extends Omit<
  ComponentProps<typeof SmallLoadingButton>,
  'color' | 'fullWidth' | 'variant'
> {
  placement: 'bulkActionsBar' | 'exportMenu';
}

export default function DispatchTriggerButton({
  placement,
  sx,
  ...buttonProps
}: DispatchTriggerButtonProps) {
  if (placement === 'bulkActionsBar') {
    return <BulkActionsBarButton color="inherit" sx={sx} {...buttonProps} />;
  }

  return (
    <SmallLoadingButton
      color="inherit"
      fullWidth
      sx={{ justifyContent: 'flex-start' }}
      variant="text"
      {...buttonProps}
    />
  );
}
